import {
  useEffect, useRef,
} from 'react';
import { useQuery } from '~/_shared/utils/hooks/useQuery';
import { notNullsy } from '~/_shared/utils/typeGuards';
import { useModal } from '~/modal/useModal.hook';
import { useMapInfoDataSelector } from '~/store/mapInfo/mapInfo.selectors';
import { useModalIsOpenSelector } from '~/store/modal/modal.selectors';
import { MAP_TEMPLATES_MODAL_OPEN_URL_PARAM } from '../map.helpers';

export const useAutoOpenMapTemplatesModal = () => {
  const query = useQuery();
  const openMapTemplatesUrlQuery = query.get(MAP_TEMPLATES_MODAL_OPEN_URL_PARAM);
  const { openModal: openMapTemplatesModal } = useModal('MapTemplates');
  const mapInfoData = useMapInfoDataSelector();
  const isAnyModalOpen = useModalIsOpenSelector();
  const hasOpenedRef = useRef(false);

  // Wait for any other modal to be dismissed first, rather than stacking on top of it.
  // Geocoding is intentionally not waited on here, so the modal opens right after all other modals closes
  const canOpenTemplatesModal = notNullsy(mapInfoData) && !isAnyModalOpen;

  useEffect(() => {
    if (openMapTemplatesUrlQuery === 'true' && canOpenTemplatesModal && !hasOpenedRef.current) {
      hasOpenedRef.current = true;
      openMapTemplatesModal();
    }
  }, [openMapTemplatesUrlQuery, canOpenTemplatesModal, openMapTemplatesModal]);
};
